/**
 * Comparator that orders year filter options with the most recent year first.
 *
 * Shared by the dropdown and list detail-filter categories (gated on the
 * 'year' column) so the publications and archive year filters sort the same
 * way regardless of whether the CMS delivers the category as a dropdown or a
 * list of buttons. Non-numeric options (e.g. a default "all" entry) are kept
 * ahead of the years so a reset choice stays at the top.
 *
 * Typed against the minimal `{ label: string }` shape so it is compatible with
 * both the SelectBox option type and the list category's filter items.
 */
export const sortYearsDescending = (a: { label: string }, b: { label: string }): number => {
  const yearA = Number(a.label);
  const yearB = Number(b.label);
  const aIsYear = !Number.isNaN(yearA);
  const bIsYear = !Number.isNaN(yearB);

  if (aIsYear && bIsYear) {
    return yearB - yearA;
  }
  if (aIsYear === bIsYear) {
    return 0;
  }
  return aIsYear ? 1 : -1;
};
